let timeoutId: ReturnType<typeof setTimeout> | null = null;
let skipURLStateUpdatesFlag = false;

export const skipURLStateUpdates = () => {
  if (timeoutId) {
    clearTimeout(timeoutId);
  }

  skipURLStateUpdatesFlag = true;
  timeoutId = setTimeout(() => {
    skipURLStateUpdatesFlag = false;
  }, 2000);
};

export const getSkipURLStateUpdatesFlag = () => {
  return skipURLStateUpdatesFlag;
};
